export function hasDifferentPrice(tbKind) {
	// remove blocks without rest count from comparison
	const filteredBlocks = tbKind.timeBlocks.filter(t => t.restCount !== null)

	if (filteredBlocks.length <= 1) return false
	return !filteredBlocks.every(t => t.price === filteredBlocks[0].price)
}
